import React, { useState } from 'react';
import { Gutter, GutterCap, Header } from '../../../generic/AsTable/Standard';
import CustomDiscountsDataRow from './CustomDiscountsDataRow';

const CustomDiscountsDataRows = ({
    height,
    width,
    style,
    data = [],
    onChange,
    rowHeight,
    visibleRows,
    activeRequest = {},
    readOnly,
    ...props
}) => {
    const [scrollPx, setScrollPx] = useState(0);
    const [highlightedRow, setHighlightedRow] = useState(-1);

    const padWithEmptyRows = () => {
        const retVal = [];
        for (let i = data.length; i < visibleRows; i++) {
            retVal.push(
                <CustomDiscountsDataRow
                    key={i}
                    index={i}
                    scrollPx={scrollPx}
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    hideEditable={true}
                />
            );
        }

        return retVal;
    };

    return (
        <>
            <Header
                area={`discountH`}
                style={{ borderWidth: 1 }}
                scrollPx={scrollPx}
            >
                {window.translate('Custom Discount')}
            </Header>

            <Header area={`maximumH`} scrollPx={scrollPx}>
                {window.translate('Maximum Amount %')}
            </Header>

            <Header
                area={`amountH`}
                style={{ borderWidth: '1px 0 1px 0' }}
                scrollPx={scrollPx}
            >
                {window.translate('Amount to Apply %')}
            </Header>

            <GutterCap />

            {data.map((entity, i) => (
                <CustomDiscountsDataRow
                    key={i}
                    index={i}
                    entity={entity}
                    scrollPx={scrollPx}
                    onChange={onChange}
                    onHover={setHighlightedRow}
                    isHighlighted={highlightedRow === i}
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    readOnly={readOnly}
                    hideEditable={readOnly || (Object.keys(activeRequest)?.length > 1 ? !activeRequest?.isComplete : false)}
                />
            ))}

            <Gutter
                scrollPx={scrollPx}
                onScroll={setScrollPx}
                scrollableLength={data.length * rowHeight}
                maxVisibleLength={visibleRows * rowHeight}
            />

            {padWithEmptyRows()}
        </>
    );
};

export default CustomDiscountsDataRows;
